import React from 'react'
import coinsIcon from "../../../assets/images/coins.png"
function EarnPrize() {
  return (
    <div className='p-4 mt-4 flex justify-between bg-[#F07404] rounded-2xl'>
      <div className="text-white">
        <h1 className='text-2xl font-bold'>Be a Winner</h1>
        <p className=''>Click here to start Play and earn rewards!</p>
      </div>
      <div className="">
        <img src={coinsIcon} alt="Earn Prize" />
      </div>
    </div>
  )
}

export default EarnPrize
